<ng-container *ngIf="listItemDetails?.length > 0">
  <div
    fxLayout="row"
    fxLayoutAlign="space-between center"
    *ngFor="let item of listItemDetails"
    class="mat-divider entry-layout"
  >
    <div
      class="text-overflow display-name"
      (click)="getSelectedRelative(item)"
      [matTooltip]="item.getDisplay() | displayTranslation"
    >
      {{ item.getDisplay() | displayTranslation }}
    </div>
    <num-menu
      (click)="$event.stopPropagation()"
      [menuItems]="item.getSelectable() ? menuItemsTrue : menuItemsFalse"
      [id]="item.getContextualizedTermcodeHash()"
    ></num-menu>
  </div>
</ng-container>
